<mat-form-field class="flex-full" [disabled]='props?.readonly' [required]='props.required'>
    <mat-label>{{props.label}}</mat-label>
    <textarea matInput [class]="'flex-full'" [cdkTextareaAutosize]='!!props.autosize' [id]="id"
        [readonly]="props.readonly" [required]="props.required" [formControl]="formControl"
        [errorStateMatcher]="errorStateMatcher" [cols]="props?.cols ?? 30" [rows]="props.rows ?? 3"
        [formlyAttributes]="field" [placeholder]="props.placeholder" [tabindex]="props.tabindex"
        title="{{props.label}}" [attr.aria-label]="props.label">
    </textarea>
    @if ( maxCharacters > 0 ) {
    <mat-hint [class]="{'highlight-text' : charCount >= maxCharacters}" align="end">{{charCount}} of {{maxCharacters}} characters</mat-hint>
    }
</mat-form-field>